export const apiKey = "live_0a997c99714f2745a8570714e93c978d06174b98f6081f28cc29b630c772a67ecc80bd04f491f1a063ac05904f079a48";

export const MAPLE_API_BASE_URL = "https://open.api.nexon.com/maplestory/v1";